import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API tuition_assistance_config_resource.rb; distinct from the tas-assistance type.
const TuitionAssistanceConfigSchema = withDefaults({
  type: 'tuition-assistance-config',
  fields: [
    { kind: 'attribute', name: 'tuitionPlanName' },
    { kind: 'attribute', name: 'description' },
    { kind: 'attribute', name: 'isActive' },
    { kind: 'attribute', name: 'custom' },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: { async: false, inverse: null },
    },
  ],
});

export default TuitionAssistanceConfigSchema;
